import { FC, ComponentPropsWithRef } from 'react';
import { tailwindOverride } from '@getsynapse/design-system';

interface ResourcesListItemProps extends ComponentPropsWithRef<'li'> {
  disabled?: boolean;
  onSelectOption: () => void;
  role?: string;
}

const ResourcesListItem: FC<ResourcesListItemProps> = ({
  disabled = false,
  children,
  onSelectOption,
  role,
  ...props
}) => {
  return (
    <li
      role={role}
      className={tailwindOverride(
        'group p-2 flex justify-start items-center cursor-pointer rounded h-10',
        { 'hover:bg-primary-lighter': !disabled },
        {
          'text-neutral-light cursor-not-allowed': disabled,
        }
      )}
      onClick={onSelectOption}
      {...props}
    >
      {children}
    </li>
  );
};

export default ResourcesListItem;
